import React from "react";
import PropTypes from "prop-types";
import { mediaOutletUrl } from "views_shared/app/javascript/utils/urls";
import SavedGroupsBookmark from "../../source_directory/SavedGroupsBookmark";
import LogoTile from "../../source_directory/LogoTile";
import HighlightAttribute from "../../source_directory/HighlightAttribute";
import OutletBadges from "./OutletBadges";
import mediaUserCount from "./mediaUserCount";

// Width of the trailing action column, kept in sync with the list header in ../search/InfiniteHits.
export const LIST_ACTION_COLUMN_WIDTH = 32;

function MediaOutletCardList({ hit }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: "12px 16px",
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
      }}
    >
      {/* Outlet / logo */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, flex: "0 0 240px", minWidth: 0 }}>
        <LogoTile imageUrl={hit.profile_image_url} name={hit.display_name} size={44} borderRadius={6} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            <a href={mediaOutletUrl({ slug: hit.slug, migrate_id: hit.migrate_id })} style={{ color: "#111827" }}>
              <HighlightAttribute hit={hit} attribute="display_name" fallback={hit.display_name} />
            </a>
          </div>
          {hit.domain && (
            <div style={{ fontSize: 12, color: "#6b7280" }}>
              <HighlightAttribute hit={hit} attribute="domain" fallback={hit.domain} />
            </div>
          )}
          <OutletBadges prestige={hit.prestige} outletClassification={hit.outlet_classification} marginTop={4} />
        </div>
      </div>

      {/* Media users */}
      <div style={{ flex: "0 0 120px", fontSize: 13, color: "#212528" }}>{mediaUserCount(hit.reporter_count)}</div>

      {/* Description */}
      <div
        style={{
          flex: 1,
          fontSize: 13,
          color: "#4d5357",
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <HighlightAttribute hit={hit} attribute="description" fallback={hit.description} />
      </div>

      {/* Actions — fixed-width column kept in sync with the list header */}
      <div
        style={{
          flex: `0 0 ${LIST_ACTION_COLUMN_WIDTH}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <SavedGroupsBookmark
          sourceableType="Id::MediaOutlet"
          sourceableId={hit.id}
          sourceMeta={{ name: hit.display_name, imageUrl: hit.profile_image_url, slug: hit.slug }}
        />
      </div>
    </div>
  );
}

MediaOutletCardList.propTypes = {
  hit: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slug: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    domain: PropTypes.string,
    description: PropTypes.string,
    profile_image_url: PropTypes.string,
    prestige: PropTypes.string,
    outlet_classification: PropTypes.string,
    reporter_count: PropTypes.number,
  }).isRequired,
};

export default MediaOutletCardList;
